<template>
  <div style="max-width: 1100px; margin: 0 auto; padding: 1.5rem;">

    <div v-if="loading" style="text-align: center; padding: 3rem; color: #8898aa;">
      Cargando...
    </div>

    <div v-else-if="error" style="background:#fff; border:1px solid #ffeaea; border-radius:12px; padding:20px; color:#c0002a; font-size:14px;">
      {{ error }}
    </div>

    <div v-else-if="auditoria">

      <div style="font-size: 12px; color: #8898aa; margin-bottom: 16px;">
        <span style="color: #27884d; cursor: pointer;" @click="$router.push('/auditorias')">Auditorías</span>
        <span style="margin: 0 6px;">›</span>
        <span style="color: #32325d;">Detalle · {{ formatDate(auditoria.fecha) }}</span>
      </div>

      <div style="display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 20px; flex-wrap: wrap; gap: 12px;">
        <div>
          <h2 style="font-size: 20px; font-weight: 600; color: #32325d; margin: 0 0 4px;">
            <span v-if="auditoria.codigo" style="color: #8898aa; font-weight: 400;">#{{ auditoria.codigo }} · </span>{{ auditoria.cocina }}
          </h2>
          <p style="font-size: 13px; color: #8898aa; margin: 0;">
            Auditoría {{ auditoria.tipo === 'daily' ? 'Daily' : 'Franquicia' }} ·
            <strong style="color: #525f7f;">{{ formatDate(auditoria.fecha) }}</strong> ·
            Auditor: {{ auditoria.coordinador }}
          </p>
        </div>
        <span :style="badgeEscalaStyle(auditoria.escala)" style="display:inline-block; font-size:12px; font-weight:600; padding:5px 14px; border-radius:20px;">
          {{ auditoria.escala }}
        </span>
      </div>

      <div style="display: grid; grid-template-columns: 1fr 2fr; gap: 14px; margin-bottom: 14px;">

        <div style="background:#fff; border:1px solid #e9ecef; border-radius:12px; padding:20px;">
          <p style="font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:#32325d; margin-bottom:12px;">
            Resumen general
          </p>

          <div style="display:flex; align-items:center; gap:12px; margin-bottom:14px;">
            <div>
              <div style="font-size:48px; font-weight:600; color:#32325d; line-height:1;">
                {{ auditoria.score_porcentaje }}%
              </div>
              <div style="font-size:13px; color:#8898aa; margin-top:2px;">
                {{ auditoria.score_puntos }} / {{ auditoria.score_maximo }} pts
              </div>
            </div>
            <span :style="badgeEscalaStyle(auditoria.escala)" style="display:inline-block; font-size:12px; font-weight:600; padding:4px 12px; border-radius:20px; margin-left:auto;">
              {{ auditoria.escala }}
            </span>
          </div>

          <div style="border-top:1px solid #e9ecef; padding-top:12px; display:flex; flex-direction:column; gap:8px;">
            <div style="display:flex; justify-content:space-between; font-size:13px;">
              <span style="color:#8898aa;">Ítems cumplidos</span>
              <span style="font-weight:600; color:#27884d;">{{ auditoria.items_cumplidos }} / {{ auditoria.items_total }}</span>
            </div>
            <div style="display:flex; justify-content:space-between; font-size:13px;">
              <span style="color:#8898aa;">Hallazgos</span>
              <span style="font-weight:600; color:#c0002a;">{{ auditoria.total_hallazgos }}</span>
            </div>
          </div>
        </div>

        <div style="background:#fff; border:1px solid #e9ecef; border-radius:12px; padding:20px;">
          <p style="font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:#32325d; margin-bottom:14px;">
            Resultado por bloque
          </p>
          <div style="display:flex; flex-direction:column; gap:14px;">
            <div v-for="bloque in bloques" :key="bloque.numero">
              <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:5px;">
                <div style="display:flex; align-items:center; gap:8px;">
                  <span style="background:#f6f9fc; color:#525f7f; border:1px solid #dee2e6; font-size:10px; font-weight:600; padding:2px 8px; border-radius:20px;">
                    Bloque {{ bloque.numero }}
                  </span>
                  <span style="font-size:13px; font-weight:600; color:#32325d;">{{ bloque.nombre }}</span>
                </div>
                <span style="font-size:13px; font-weight:600;" :style="{ color: colorPorcentaje(bloque.porcentaje) }">
                  {{ bloque.puntos_obtenidos }} / {{ bloque.puntos_maximos }} pts · {{ bloque.porcentaje }}%
                </span>
              </div>
              <div style="background:#f6f9fc; border-radius:99px; height:6px; overflow:hidden;">
                <div style="height:6px; border-radius:99px;" :style="{ width: bloque.porcentaje + '%', background: colorPorcentaje(bloque.porcentaje) }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="background:#fff; border:1px solid #e9ecef; border-radius:12px; padding:20px; margin-bottom:14px;">
        <p style="font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:#32325d; margin-bottom:14px;">
          Checklist completo
        </p>

        <div style="display:flex; flex-direction:column; gap:8px;">
          <div v-for="bloque in bloques" :key="'bl-' + bloque.numero">

            <div
              @click="toggleBloque(bloque.numero)"
              style="display:flex; align-items:center; justify-content:space-between; padding:12px 14px; border-radius:8px; cursor:pointer; background:#f6f9fc; border:1px solid #e9ecef;"
            >
              <div style="display:flex; align-items:center; gap:10px;">
                <span style="background:#f6f9fc; color:#525f7f; border:1px solid #dee2e6; font-size:10px; font-weight:600; padding:2px 8px; border-radius:20px;">
                  Bloque {{ bloque.numero }}
                </span>
                <span style="font-size:13px; font-weight:600; color:#32325d;">{{ bloque.nombre }}</span>
                <span v-if="bloque.total_hallazgos > 0" style="font-size:11px; font-weight:600; padding:2px 8px; border-radius:20px; background:#ffeaea; color:#c0002a;">
                  {{ bloque.total_hallazgos }} {{ bloque.total_hallazgos === 1 ? 'hallazgo' : 'hallazgos' }}
                </span>
                <span v-else style="font-size:11px; font-weight:600; padding:2px 8px; border-radius:20px; background:#e6f5ec; color:#27884d;">
                  Sin hallazgos
                </span>
              </div>
              <div style="display:flex; align-items:center; gap:12px;">
                <span style="font-size:13px; font-weight:600;" :style="{ color: colorPorcentaje(bloque.porcentaje) }">
                  {{ bloque.puntos_obtenidos }} / {{ bloque.puntos_maximos }} pts
                </span>
                <svg :style="{ transform: bloquesAbiertos[bloque.numero] ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <polyline points="3,5 7,9 11,5" stroke="#8898aa" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>

            <div v-show="bloquesAbiertos[bloque.numero]" style="padding: 4px 0;">
              <div v-for="item in bloque.items" :key="item.numero" style="display:flex; align-items:center; gap:12px; padding:10px 0; border-bottom:1px solid #f6f9fc;">
                <div style="width:24px; height:24px; border-radius:50%; background:#f6f9fc; border:1px solid #dee2e6; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:600; color:#525f7f; flex-shrink:0;">
                  {{ item.numero }}
                </div>
                <div v-if="item.cumple" style="width:22px; height:22px; border-radius:50%; background:#e6f5ec; display:flex; align-items:center; justify-content:center; flex-shrink:0;">
                  <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="2,5 4,7 8,3" stroke="#27884d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
                </div>
                <div v-else style="width:22px; height:22px; border-radius:50%; background:#ffeaea; display:flex; align-items:center; justify-content:center; flex-shrink:0;">
                  <svg width="10" height="10" viewBox="0 0 10 10"><line x1="2" y1="2" x2="8" y2="8" stroke="#c0002a" stroke-width="1.5" stroke-linecap="round"/><line x1="8" y1="2" x2="2" y2="8" stroke="#c0002a" stroke-width="1.5" stroke-linecap="round"/></svg>
                </div>
                <span style="flex:1; font-size:13px; color:#32325d;">{{ item.descripcion }}</span>
                <span style="font-size:12px; color:#8898aa; white-space:nowrap;">
                  {{ item.puntos_obtenidos }} / {{ item.puntos_maximos }} pts
                </span>
                <span style="font-size:10px; font-weight:600; padding:2px 8px; border-radius:20px; white-space:nowrap;" :style="item.cumple ? 'background:#e6f5ec; color:#27884d;' : 'background:#ffeaea; color:#c0002a;'">
                  {{ item.cumple ? 'Cumple' : 'No cumple' }}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div v-if="totalFotos > 0" style="background:#fff; border:1px solid #e9ecef; border-radius:12px; padding:20px;">
        <p style="font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:#32325d; margin-bottom:6px;">
          Fotos de hallazgos
        </p>
        <p style="font-size:12px; color:#8898aa; margin-bottom:16px;">
          Registradas por el auditor durante la visita · {{ totalFotos }} fotos
        </p>

        <div style="display:flex; flex-direction:column; gap:14px;">
          <div v-for="hallazgo in fotosHallazgos" :key="hallazgo.bloque_numero + '-' + hallazgo.item_numero" style="border:1px solid #e9ecef; border-radius:10px; padding:14px;">
            <div style="display:flex; align-items:center; gap:8px; margin-bottom:12px; flex-wrap:wrap;">
              <span style="background:#f6f9fc; color:#525f7f; border:1px solid #dee2e6; font-size:10px; font-weight:600; padding:2px 8px; border-radius:20px;">
                Bloque {{ hallazgo.bloque_numero }} · Ítem {{ hallazgo.item_numero }}
              </span>
              <span style="font-size:13px; font-weight:600; color:#32325d;">{{ hallazgo.item_descripcion }}</span>
              <span style="background:#ffeaea; color:#c0002a; font-size:10px; font-weight:600; padding:2px 8px; border-radius:20px; margin-left:auto;">
                No cumple
              </span>
            </div>

            <div style="display:flex; gap:10px; flex-wrap:wrap; margin-bottom:10px;">
              <img v-for="(foto, idx) in hallazgo.fotos" :key="idx" :src="foto.url" style="width:80px; height:80px; border-radius:8px; object-fit:cover; border:1px solid #e9ecef; cursor:pointer;" @error="onImgError($event)" @click="verFoto(foto.url)" />
            </div>

            <p v-if="hallazgo.nota" style="font-size:12px; color:#8898aa; margin:0;">
              {{ hallazgo.nota }}
            </p>
          </div>
        </div>
      </div>

    </div>

    <div
      v-if="fotoAmpliada"
      @click="cerrarFoto"
      style="position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.85); display:flex; align-items:center; justify-content:center; z-index:9999; cursor:zoom-out; padding:24px;"
    >
      <img :src="fotoAmpliada" style="max-width:90%; max-height:90%; border-radius:8px; object-fit:contain;" />
    </div>
  </div>
</template>

<script>
import AuditoriasGateway from '@/gateways/AuditoriasGateway'
import { estiloEscalaCss } from './escalas'

export default {
  name: 'DetalleAuditoria',
  data: function () {
    return {
      loading: true,
      error: null,
      auditoria: null,
      bloques: [],
      fotosHallazgos: [],
      bloquesAbiertos: {},
      fotoAmpliada: null
    }
  },
  computed: {
    totalFotos: function () {
      return this.fotosHallazgos.reduce(function (acc, h) { return acc + h.fotos.length }, 0)
    }
  },
  created: function () {
    this.cargarDetalle()
  },
  methods: {
    formatDate: function (dateStr) {
      if (!dateStr) return ''
      var d = new Date(dateStr.indexOf('T') === -1 ? dateStr + 'T00:00:00' : dateStr)
      if (isNaN(d.getTime())) return dateStr
      var months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
      return d.getDate() + ' de ' + months[d.getMonth()] + ' de ' + d.getFullYear()
    },
    cargarDetalle: function () {
      var self = this
      var id = this.$route.params.id
      AuditoriasGateway.obtenerDetalle(id)
        .then(function (res) {
          self.auditoria = res.data.auditoria
          self.bloques = res.data.bloques
          self.fotosHallazgos = res.data.fotos_hallazgos || []

          var maxHallazgos = 0
          var bloqueAbrir = null
          res.data.bloques.forEach(function (b) {
            if (b.total_hallazgos > maxHallazgos) {
              maxHallazgos = b.total_hallazgos
              bloqueAbrir = b.numero
            }
          })
          var abiertos = {}
          res.data.bloques.forEach(function (b) {
            abiertos[b.numero] = b.numero === bloqueAbrir
          })
          self.bloquesAbiertos = abiertos
        })
        .catch(function () {
          self.error = 'No se pudo cargar la auditoría. Intenta de nuevo.'
        })
        .finally(function () {
          self.loading = false
        })
    },
    toggleBloque: function (numero) {
      var estado = Object.assign({}, this.bloquesAbiertos)
      estado[numero] = !estado[numero]
      this.bloquesAbiertos = estado
    },
    badgeEscalaStyle: function (escala) {
      return estiloEscalaCss(escala)
    },
    colorPorcentaje: function (pct) {
      if (pct >= 85) return '#27884d'
      if (pct >= 70) return '#185fa5'
      if (pct >= 60) return '#f2a000'
      return '#c0002a'
    },
    onImgError: function (event) {
      event.target.style.display = 'none'
    },
    verFoto: function (url) {
      this.fotoAmpliada = url
    },
    cerrarFoto: function () {
      this.fotoAmpliada = null
    }
  }
}
</script>
